export default {
  SET_INVITES: (state, payload) => {
    state.invites = payload.map((invite) => ({ ...invite, invite: true }));
  },
  SET_PAGINATION: (state, payload) => {
    state.pagination = { ...payload };
  },
};
